import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getMovieTrailerOtt(
    trailer: LegacyOttTrailerPlayerBaseInfoContent | undefined | null
) {
    if (trailer?.__typename === 'OttTrailer') {
        return trailer;
    }
}
